import { render, staticRenderFns } from "./ZoneBaseData.vue?vue&type=template&id=250b31e9"
import script from "./ZoneBaseData.vue?vue&type=script&lang=js"
export * from "./ZoneBaseData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports